<template>
  <div class="header-bd ub ub-sp ub-xc">
    <div class="hd-left">
      <div class="tags">
        <span v-for="(item, index) in levelList" :key="item.path" :style="{ color: index == levelList.length - 1 ? '#1A1A1A' : '#818181' }">
          <span v-if="index !== 0">/</span>
          {{ item.meta.langCode && !isDev ? $t(item.meta.langCode) : item.meta.title }}
        </span>
      </div>
      <div class="ub ub-xc">
        <div class="back" @click="onBack" v-if="$route.meta.showBack">
          <i class="icon icon-chexiao"></i>
        </div>
        <h1>{{ $route.meta.langCode && !isDev ? $t($route.meta.langCode) : $route.meta.title }}</h1>
      </div>
    </div>
    <div class="hd-right ub">
      <div class="timer" @click="onSyncLang()">
        <h2 v-if="serviceTime">{{ $t('com_service_time') }}：{{ momentAmPm(serviceTime) }} {{ userInfo.timeZoneName }}<span v-if="timeZoneShort && timeZoneIdList.length> 1"> {{timeZoneShort}}</span> </h2>
      </div>
      <div class="app ub" style="margin-right: 12px">
        <el-popover placement="bottom" title="i-Synergy APP" width="240" trigger="hover">
          <div slot="reference" class="hd-icon">
            <i class="icon icon-app"></i>
          </div>
          <div style="text-align: center; padding-top: 8px" v-if="csAppResPath">
            <qrcode-vue :value="csAppResPath" :size="144"></qrcode-vue>
            <div style="line-height: 24px; font-size: 13px; color: #898989">{{ $t('header_ban_ben_hao') }}：{{ csAppVersion }}</div>
          </div>
          <p style="text-align: center; margin: 10px 0 10px">{{ $t('header_smewmxz') }}</p>
        </el-popover>
      </div>
      <div class="name ub" @click="jump('/account/manage')">
        <div class="hd-icon">
          <!-- 客户 -->
          <i v-if="userInfo.bizType === 'CS'" class="icon icon-yonghu"></i>
          <!-- 大客户 -->
          <i v-if="userInfo.bizType === 'CO'" class="icon icon-bumen1"></i>
          <!-- 商务公司 -->
          <i v-if="userInfo.bizType === 'JV'" class="icon icon-jituangongsi"></i>
        </div>
        <h2>{{ userInfo.realName }}</h2>
      </div>
      <div class="lang ub">
        <div class="hd-icon">
          <i class="icon icon-yuyan"></i>
        </div>
        <div>
          <el-dropdown>
            <div class="ub">
              <div class="dropdown-lang">
                {{ language }}
              </div>
              <div class="lang-icon">
                <i class="icon icon-xiala"></i>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown" style="width: 210px; border-radius: 8px; padding: 10px 14px">
              <el-dropdown-item v-for="(value, index) in languageTypes" :key="index" @click.native="changeLang(value)">
                <div style="height: 34px; line-height: 34px">{{ value.name }}</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="msg ub" @click="toMessageCenter">
        <div class="hd-icon">
          <i class="icon icon-xiaoxi"></i>
        </div>
        <h2>({{ messageNum }})</h2>
      </div>
      <div class="out" @click="signout">
        <div class="hd-icon">
          <i class="icon icon-tuichu"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Cookies from 'js-cookie';
import moment from 'moment';
import QrcodeVue from 'qrcode.vue';
import apis from '@/utils/apis';

// header_ban_ben_hao: 版本号// header_smewmxz: 扫描二维码下载

export default {
  components: { QrcodeVue },
  data() {
    return {
      serviceTime: '',
      timeZoneShort: '',
      timeInterval: null,
      levelList: null,
      langCode: '',
      language: '',
      languageTypes: [],
      messageWebSocket: null,
      getMsgHandler: null,
      csAppResPath: '',
      csAppVersion: '',
      timeZoneIdList: [],
    };
  },

  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  created() {
    this.getTimeZoneIdList();
    this.getBreadcrumb();
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_header');
    this.langCode = Cookies.get('langCode');
    this.$i18n.locale = this.langCode;
    this.getLangList();
    this.getMsgStatistics();
    this.getAppVersion();
    this.initWebSocket();

    this.getMsgHandler = this.$debounce((data) => {
      this.getMsgStatistics();
      // 消息提示
      const h = this.$createElement;
      this.$notify({
        title: data.title || '',
        message: h('i', { style: 'color: #6C757D' }, data.content || ''),
        // type: 'warning',
        duration: 3000,
        position: 'top-right',
        onClick: () => {
          this.jump('/messageCenter');
        },
      });
    }, 10000);

    // setTimeout(() => {
    //   this.messageWebSocket.heartCheck('send');
    // }, 1000);
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo || {},
      messageNum: state => state.messageNum || 0,
    }),
  },
  destroyed: function () {
    this.messageWebSocket = null;
    clearInterval(this.timeInterval);
  },
  methods: {
    getTimeZoneIdList: function () {
      this.$getJSON(apis.timeZoneGetCompanyList).then((res) => {
        this.timeZoneIdList = res.data;
      });
    },
    getAppVersion: function () {
      this.$getJSON(apis.AppCsVersion, {
        appOs: 'android',
        currentVersion: '1.0.0',
      }).then((res) => {
        this.csAppResPath = res.data.resPath;
        this.csAppVersion = res.data.versionCode;
      });
    },
    // 同步多语言
    onSyncLang() {
      if (this.isDev) {
        this.Bus.$emit('asyncLanguage');
      }
    },
    runServiceTime(timer) {
      const utcOffset = moment.utc(timer).diff(moment.utc(), 'seconds');
      this.timeInterval = setInterval(() => {
        this.serviceTime = this.$momentLocal(moment.utc().add(utcOffset, 's'));
      }, 1000);
    },
    // 获取面包屑
    getBreadcrumb() {
      const matched = this.$route.matched.filter(item => item.meta && item.meta.title);
      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false);
    },
    // 返回页面
    onBack() {
      const route = this.levelList[this.levelList.length - 2];
      this.$router.replace({ path: route.path, query: this.$route.query, params: this.$route.params });
    },
    // 跳转消息中心
    toMessageCenter() {
      this.jump('/messageCenter');
    },
    // 获取多语言下拉列表
    getLangList: function () {
      this.getDictionary('language_type', (dic) => {
        this.languageTypes = dic.language_type || [];
        const lang = this.languageTypes.find(t => t.value === this.langCode) || {};
        this.language = lang.name;
      });
    },
    // 获取未读消息
    getMsgStatistics() {
      this.$getJSON(apis.msgRecordTotalInit, {}, true).then((res) => {
        this.runServiceTime(res.data.sysTime);
        this.timeZoneShort = res.data.timeZoneDto && res.data.timeZoneDto.timeZoneShort || '';
        // 刷新未读消息数
        const msgStatistics = res.data.unReadCounts.totalCounts || 0;
        this.$store.commit('MESSAGEWS', msgStatistics);
      });
    },
    // 切换语言
    changeLang: function (item) {
      if (item.value !== this.langCode) {
        // 页面多语言切换
        this.langCode = item.value;
        Cookies.set('langCode', item.value, { path: '/' });
        const lang = this.languageTypes.find(t => t.value === this.langCode) || {};
        this.language = lang.name;
        // element多语言切换
        // this.$i18n.locale = item.value;
        this.$router.go(0);
      }
    },
    // 退出登录
    signout: function () {
      this.$postJSON(apis.Logout).finally(() => {
        this.$store.commit('LOGINOUT');
        Cookies.remove('loginName', { path: '/' });
        Cookies.remove('token', { path: '/' });
        Cookies.remove('tokenTimeOut', { path: '/' });
        Cookies.remove('nonMetric', { path: '/' });
        Cookies.remove('langCode', { path: '/' });
        this.$router.replace({ path: '/login', query: {} });
      });
    },
    initWebSocket: function () {
      // ws:// 82.157.123.54:9010/ajaxchattest
      // 493058936701386752
      const userId = this.$store.state.userInfo.userId;
      const domain = document.domain;
      // 线上地址 /ice/websocket/{userId}
      // 本地地址`ws://192.168.11.130:8421/websocket/${userId}`
      if (this.isDev) {
        this.messageWebSocket = this.$connectWebSocketClass(`ws://192.168.11.130:8421/websocket/${userId}`, this.wsClassBack, 'messageWebSocket'); //
      } else {
        this.messageWebSocket = this.$connectWebSocketClass(`ws://${domain}/ice/websocket/${userId}`, this.wsClassBack, 'messageWebSocket'); //
      }
      const tips = this.$t('com_ws_connect_tips');
      this.messageWebSocket.connect(tips); // 连接服务器
    },
    // 实时消息回调
    wsClassBack(data) {
      // this.$store.commit('MESSAGEWS');
      // 同步消息数

      this.getMsgHandler(JSON.parse(data));
    },
  },
};
</script>
<style lang="scss">
@import '@/style/mixin.scss';

.header-bd {
  height: 88px;
  .hd-left {
    padding-left: 24px;
    .tags {
      font-size: 12px;
      color: #818181;
      margin-bottom: 8px;
      span.cur {
        color: #1a1a1a;
      }
    }
    .back {
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 20px;
      background-color: $--color-warning;
      text-align: center;
      margin-right: 8px;
      cursor: pointer;
      i.icon {
        font-size: 13px;
        color: $--color-text-primary;
      }
    }
    h1 {
      color: #202945;
      font-weight: bold;
      font-size: 16px;
    }
  }
  .hd-right {
    padding-right: 40px;
    h2 {
      line-height: 32px;
      color: #202945;
      font-size: 14px;
      cursor: pointer;
    }
    i.icon {
      cursor: pointer;
      line-height: 32px;
      font-size: 18px;
      margin-right: 8px;
      color: #4d4d4d;
    }
    .timer {
      margin-right: 33px;
    }
    .name {
      margin-right: 22px;
    }
    .lang {
      cursor: pointer;
      margin-right: 18px;
      i.icon {
        line-height: 30px;
      }
      .dropdown-lang {
        height: 32px;
        line-height: 32px;
        color: #1a1a1a;
        font-size: 14px;
      }
      .lang-icon {
        padding-left: 4px;
        height: 32px;
        color: #1a1a1a;
        i.icon {
          line-height: 29px;
        }
      }
    }
    .msg {
      background: #ffad00;
      border-radius: 100px;
      padding-left: 11px;
      padding-right: 11px;
      i.icon {
        line-height: 32px;
        font-size: 18px;
        margin-right: 2px;
        color: #202945;
      }
    }
    .out {
      height: 32px;
      line-height: 32px;
      margin-left: 24px;
    }
  }
}
</style>
